export const NOTIFICATIONS_ROUTES = {
  __ROOT__: '/notifications',
  SETTINGS: '/notifications/settings',
  VIEW_NOTIFICATION: '/notifications/:notificationId',
}
